import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { type SxProps, styled, type Theme } from '@mui/material/styles';
import Typography, { type TypographyProps } from '@mui/material/Typography';

const StyledContainerGrid = styled(Grid, { shouldForwardProp: prop => prop !== 'marginTopValue' })<{
  marginTopValue: number;
}>`
  margin: ${({ theme, marginTopValue }) => theme.spacing(marginTopValue, -2.5, 0)};
  padding: ${({ theme }) => theme.spacing(0, 2.5)};
  width: auto;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.boxDark};

    .clearIcon {
      visibility: visible;
    }
  }
`;

const StyledRemoveIconButton = styled(IconButton)`
  padding: ${({ theme }) => theme.spacing(0.5)};
  visibility: hidden;
`;

const StyledTitleTypography = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  text-transform: none;

  && {
    font-size: 13px;
    line-height: 28px;
  }
`;

interface SectionTitleProps {
  onClear?: () => void;
  title: string;
  readonly?: boolean;
  sx?: SxProps<Theme>;
  variant?: TypographyProps['variant'];
  marginTopValue?: number;
  isDisabled?: boolean;
  disabledReasonMessage?: string;
  color?: TypographyProps['color'];
}

export function FiltersTitle({
  onClear,
  title,
  disabledReasonMessage,
  readonly,
  sx,
  variant = 'h3',
  marginTopValue = 3,
  color,
}: SectionTitleProps) {
  return (
    <StyledContainerGrid
      container
      data-test={`section-${title.toLowerCase().replace(/\s/g, '-').split('-[')[0]}`}
      sx={[{ alignItems: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
      marginTopValue={marginTopValue}
    >
      <StyledTitleTypography
        variant={variant}
        color={disabledReasonMessage ? 'error' : color}
        data-test={`targeting-${title.replace(/\s/g, '-').split('-[')[0].toLocaleLowerCase().replaceAll(' ', '-')}`}
      >
        {title}
      </StyledTitleTypography>

      {!readonly && (
        <StyledRemoveIconButton className="clearIcon" onClick={onClear} size="large" data-test="close-button">
          <CloseIcon data-test="close-dialog" fontSize="small" />
        </StyledRemoveIconButton>
      )}

      {disabledReasonMessage && (
        <Typography
          color="error"
          sx={{
            width: '100%',
            mt: 1,
          }}
        >
          {disabledReasonMessage}
        </Typography>
      )}
    </StyledContainerGrid>
  );
}
